import makeStyles from '@mui/styles/makeStyles';
import { _palette } from '@p81-common/ui';

const createClasses = makeStyles(theme => ({
  welcomeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: theme.spacing(1)
  },
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },
  messageList: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  },
  messageBubble: {
    maxWidth: '70%',
    padding: theme.spacing(1.25, 2),
    borderRadius: 16,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  userBubble: {
    alignSelf: 'flex-end',
    backgroundColor: _palette.primary[500],
    color: '#fff',
    borderBottomRightRadius: 4
  },
  botBubble: {
    alignSelf: 'flex-start',
    backgroundColor: _palette.grey[100],
    color: _palette.grey[900],
    borderBottomLeftRadius: 4
  },
  typingContainer: {
    alignSelf: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  typingBubble: {
    padding: theme.spacing(1.5, 2.5),
    borderRadius: 16,
    borderBottomLeftRadius: 4,
    backgroundColor: _palette.grey[100],
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  inputRow: {
    flexShrink: 0,
    borderTop: `1px solid ${_palette.grey[200]}`,
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center'
  },
  suggestedActionsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2)
  },
  suggestedActionButton: {
    borderRadius: 20,
    textTransform: 'none' as const,
    fontWeight: 400
  },
  feedbackRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    alignItems: 'center'
  },
  feedbackButton: {
    padding: theme.spacing(0.5),
    color: _palette.grey[400],
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      color: _palette.grey[600],
      backgroundColor: _palette.grey[200]
    }
  },
  feedbackButtonActive: {
    color: _palette.primary[500],
    '&:hover': {
      color: _palette.primary[500]
    }
  }
}));

export default createClasses;
